<template>
  <ReactPage>
    <access-log-report-page></access-log-report-page>
  </ReactPage>
</template>

<script>
import ReactPage from '../components/ReactPage.vue';

export default {
  name: "AccessLogReport",
  components: {
    ReactPage
  }
}
</script>